import type { SearchableSelectOption } from "@/components/ui/SearchableSelect";

export type HubUserSelectOption = {
  userId: string;
  email: string;
  displayName: string | null;
};

function formatHubUserLabel(user: HubUserSelectOption): string {
  const name = user.displayName?.trim();
  return name ? `${name} (${user.email})` : user.email;
}

export function formatHubUserShortLabel(user: HubUserSelectOption): string {
  const name = user.displayName?.trim();
  return name && name !== "" ? name : user.email;
}

export function hubUsersToSearchableOptions(users: HubUserSelectOption[]): SearchableSelectOption[] {
  return users.map((user) => ({
    value: user.userId,
    label: formatHubUserLabel(user),
  }));
}
